import Breadcrumbs from '../../../src/components/Breadcrumbs';
import ChangeHistorySummary from "../Calculator_PaymentChange/PCH_partial_HistoryReport";

import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
const PaymentChangeHistory = () => {

  useEffect(() => {
    Swal.fire({
        icon: "warning",
        title: "Reminder to all users",
        text: "This page is currently intended for testing only. For any concerns, please reach out to the development team.",
        confirmButtonColor: '#A5CC2D', 
      });
  }, []);
  
  return (
      <div className="app-container">
         <div className="container">
            <h1>Payment Change History</h1>
            <Breadcrumbs />
            <div className="app-column">
             <ChangeHistorySummary />
            </div>
            <label className="custom-footer">© 2025 Pacific Debt Relief. All rights reserved. </label>
            <br/> <br/> <br/> <br/>
          </div> 
      </div>
  );
};

export default PaymentChangeHistory;